import { Timeframe } from "../models/enum/timeframe.enum";

export class TimeframeHelper {
    static getDateTimeTooltipFormat(timeframe: Timeframe): string {
        let result = 'mm-dd-yy';

        if (TimeframeHelper.timeframeIntraday(timeframe))
            result += ' SH:MM';

        return result;
    }

    static timeframeIntraday(timeframe: Timeframe): boolean {
        return timeframe >= 0 && timeframe <= 7;;
    }

    static getHistoryTime(timeframe: Timeframe): number {
        const hour = 60 * 60 * 1000;
        return hour * TimeframeHelper.getFocusInMinuteByTimeframe(timeframe);
    }

    static getFocusInMinuteByTimeframe(timeframe: Timeframe): number {
        switch (timeframe) {
            case Timeframe.TwoMinute: {
                return 2;
            }
            case Timeframe.ThreeMinute: {
                return 3;
            }
            case Timeframe.FiveMinute: {
                return 5;
            }
            case Timeframe.FifteenMinute: {
                return 15;
            }
            case Timeframe.ThirtyMinute: {
                return 30;
            }
            case Timeframe.SixtyMinute: {
                return 60;
            }
            case Timeframe.Day: {
                return 1440;
            }
            case Timeframe.Week: {
                return 10080;
            }
            case Timeframe.Month: {
                return 43200;
            }
        }

        return 1;
    }

    static getDailyChartTimeFrameCandleSize(timeframe: Timeframe): string {
        switch (timeframe) {
            case Timeframe.Day: {
                return 'day';
            }
            case Timeframe.Week: {
                return 'week';
            }
            case Timeframe.Month: {
                return 'month';
            }
            case Timeframe.OneMonthRange: {
                return 'day';
            }
            case Timeframe.SixMonthRange: {
                return 'day';
            }
            case Timeframe.OneYearRange: {
                return 'day';
            }
            case Timeframe.YearToDateRange: {
                return 'day';
            }
            case Timeframe.FiveYearRange: {
                return 'month';
            }
            default: {
                return '';
            }
        }
    }

    static getIntradayChartTimeFrameMinutePerCandle(timeframe: Timeframe): number {
        switch (timeframe) {
            case Timeframe.OneMinute: {
                return 1;
            }
            case Timeframe.TwoMinute: {
                return 2;
            }
            case Timeframe.ThreeMinute: {
                return 3;
            }
            case Timeframe.FiveMinute: {
                return 5;
            }
            case Timeframe.TenMinute: {
                return 10;
            }
            case Timeframe.FifteenMinute: {
                return 15;
            }
            case Timeframe.ThirtyMinute: {
                return 30;
            }
            case Timeframe.SixtyMinute: {
                return 60;
            }
            default: {
                return 0;
            }
        }
    }
}
